import { zLocale } from '../../i18n'
import {
  zAnnotationArea,
  zAnnotationHorizontalLine,
  zAnnotationPoint,
  zAnnotationVerticalLine,
  zBackgroundColor,
  zBarMaxWidth,
  zBarStyle,
  zColor,
  zCrosshairRect,
  zDataset,
  zDimensionLinkage,
  zDimensions,
  zEncoding,
  zLabel,
  zLegend,
  zMeasures,
  zCornerRadius,
  zStackCornerRadius,
  zTheme,
  zTooltip,
  zBrush,
  zXLinearAxis,
  zYBandAxis,
  zPage,
  zPlayer,
  zSort,
  zSortLegend,
} from '../../properties'

import { z } from 'zod'

export const zRaceBar = z.object({
  chartType: z.literal('raceBar'),
  dataset: zDataset.nullish(),
  encoding: zEncoding.nullish(),
  dimensions: zDimensions.nullish(),
  measures: zMeasures.nullish(),
  page: zPage.nullish(),
  player: zPlayer.nullish(),
  sort: zSort.nullish(),

  backgroundColor: zBackgroundColor.nullish(),
  color: zColor.nullish(),
  label: zLabel.nullish(),
  legend: zLegend.nullish(),
  tooltip: zTooltip.nullish(),
  brush: zBrush.nullish(),
  xAxis: zXLinearAxis.nullish(),
  yAxis: zYBandAxis.nullish(),
  crosshairRect: zCrosshairRect.nullish(),
  cornerRadius: zCornerRadius.nullish(),
  stackCornerRadius: zStackCornerRadius.nullish(),
  barMaxWidth: zBarMaxWidth.nullish(),
  sortLegend: zSortLegend.nullish(),
  theme: zTheme.nullish(),
  barStyle: z.array(zBarStyle).or(zBarStyle).nullish(),
  annotationPoint: z.array(zAnnotationPoint).or(zAnnotationPoint).nullish(),
  annotationVerticalLine: z.array(zAnnotationVerticalLine).or(zAnnotationVerticalLine).nullish(),
  annotationHorizontalLine: z.array(zAnnotationHorizontalLine).or(zAnnotationHorizontalLine).nullish(),
  annotationArea: z.array(zAnnotationArea).or(zAnnotationArea).nullish(),
  dimensionLinkage: zDimensionLinkage.nullish(),
  locale: zLocale.nullish(),
})
